import type { Product } from '../types';
import './ProductNutritionalTable.css'

export type Props = {
  product: Product,
  nutritionalValues: any,
};

const ProductNutritionalTable = ({product, nutritionalValues}: Props) => {
  return (
  <div className="info-box">
  <h5 className="info-table-title">Informação Nutricional</h5>
  <div className="info-table-wrapper">
    <p className="portion-text">{`Porção${
      product.unitForQuantity === "un" ? " por pacote" : ""
    }: ${nutritionalValues.nutritionalInfoPortion}`}</p>
    <table className="info-table">
      <thead className="info-table-header">
        <tr>
          <th className="cell-head-empty">{""}</th>
          <th className="cell-head-portion">Quantidade por porção</th>
          <th className="cell-head-percent">%VD*</th>
        </tr>
      </thead>
      <tbody>
        {nutritionalValues.nutritionValues.map((nutritionalValue, id) => (
          <tr key={id}>
            <td className="cell-name">{nutritionalValue.nameWithUnit}</td>
            <td className="cell-value">{nutritionalValue.amount}</td>
            <td className="cell-percent">{nutritionalValue.percentageOfDailyAmount || '--'}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <p className="disclaimer">
      *% Valores diários de referência com base em uma dieta de
      2.000 kcal ou 8.400 kJ. Seus valores diários podem ser
      maiores ou menores dependendo de suas necessidades
      energéticas. **VD não estabelecido.
    </p>
  </div>
</div>

  )
}

export default ProductNutritionalTable